<template>
  <div class="join-screen">
    <h1>What's your name?</h1>
    <div>
        <input type="text" v-if="conversationId" v-model="name"
            v-on:keydown.enter="joinConversation(conversationId)" autofocus/>
        <input type="text" v-else v-model="name"
            v-on:keydown.enter="startConversation" autofocus/>
    </div>
    <button type="button" v-if="conversationId"
        v-on:click="joinConversation(conversationId)">
        Join conversation
    </button>
    <button type="button" v-else
        v-on:click="startConversation">
        Start conversation
    </button>
  </div>
</template>

<script>
import { db } from '../db'

export default {
  name: 'JoinScreen',

  props: {
      conversationId: String,
      startNewConversation: Boolean,
      suggestedName: String
  },

  data() {
      return {
          name: this.prefillName()
      }
  },

  methods: {
      prefillName: function() {
          return this.suggestedName || localStorage.lastUsedName || '';
      },



      joinConversation: function(conversationId) {
          const conversation = db.collection('conversations').doc(conversationId);
          conversation.collection('members').add({ name: this.name }).then(docRef => {
              const memberId = docRef.id;
              //TODO consider a library or a wrapper for localStorage
              let conversationMap = JSON.parse(localStorage.conversationMap);
              conversationMap[conversationId] = memberId;
              localStorage.conversationMap = JSON.stringify(conversationMap);
              localStorage.lastUsedName = this.name;
              this.$router.push('/' + conversationId);
          });
      },

      startConversation: function() {
          db.collection('conversations').add({}).then(docRef => {
              const conversationId = docRef.id;
              this.joinConversation(conversationId);
          });
      }
  }
}
</script>

<style scoped>
.join-screen {
    padding-top: 200px;
    text-align: center;
}

h1 {
    margin-top: 0;
    color: #6d547e;
}

input {
    padding: 10px;
    border-radius: 10px;
    outline: none;
    font-size: 24px;
    border: 1px solid #6d547e;
}

button {
    margin-top: 30px;
    padding: 10px 15px;
    border-radius: 8px;
    border: none;
    background-color: #6d547e;
    font-size: 18px;
    color: white;
    outline: none;
}

</style>
